import React, { useState, useMemo, useEffect } from 'react';
import { CARD_MODE, GRID_MODE, OPERATORS, TYPES, TYPE_CHECKBOX, TYPE_DATE } from '../../common/list-utils';
import { CollaboratorCardList } from './List/CollaboratorCardList';
import { CollaboratorGridList } from './List/CollaboratorGridList';
import { ListColumnFilter } from '../Common/list-entities/ListColumnFilter';
import { useNavigate } from 'react-router-dom';
import { routes } from '../../common/constants';
import TimeTaxSupportSystemClient from '../../system';
import useAsyncDataCourier from '../../common/custom-hooks/useAsyncDataCourier';
import MessageCourier from '../../lib/MessageCourier';
import { useTranslation, Trans } from 'react-i18next';
import { IComboBoxOption } from '@fluentui/react';
import { User } from '../../system/User';
import useUserProfiles from '../../shared/hooks/useUserProfiles';

interface ICollaboratorList {
  system: TimeTaxSupportSystemClient;
  courier: MessageCourier;
  changeBlockUI: (state: boolean) => void;
  user: User
}

export const CollaboratorList = (props: ICollaboratorList) => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [mode, setMode] = useState(GRID_MODE);
  const [listLevels,setListLeves] = useState<any>([]);
  
  const { profiles } = useUserProfiles(props.system.getUserProfileSystem())

  const nodes = useAsyncDataCourier(
      () => props.system.getOrganizationChartSystem().getAllNodes(),
      [props.system],
      props.courier
  );

  const listcargo = useAsyncDataCourier(
    () => props.system.listCargoTypeComboBoxOptions(),
    [props.system],
    props.courier
   );

  const getLevelsNodes = async ()=>{
    const respuesta = await props.system?.getOrganizationChartSystem().getLevels();
    const formattedLevels = await Promise.all(
      respuesta.map(async (item: any) => {
        const organigramaData = await props.system?.getOrganizationChartSystem().getLastLevelNodesss(item.level);
        return {
          quick: false,
          name: item.nameTec,
          type: TYPES.COMBOBOXTEXT,
          placeholder: t(item.name),
          operator: OPERATORS.CONTAINS,
          contextForCombobox: organigramaData.levels.map((opt: any) => ({ ...opt, title: opt.text })),
        };
      })
    );

    setListLeves([...formattedLevels]);
  }

  useEffect(() =>{
    getLevelsNodes();
  }, []);


  const baseUrl = React.useMemo(() => {
    return props.system.getCollaboratorSystem().getBaseUrlForDatagrid();
  }, [props]);

  const onItemClick = (item: any) => {
    navigate(`${routes.collaborator}/${item.col_id}`);
  };

  const quickFilters: ListColumnFilter[] = useMemo(
      () => [
        {
          quick: true,
          name: 'col_id_sap',
          type: TYPES.INPUT,
          placeholder: t('Cod. SAP'),
          operator: OPERATORS.CONTAINS,
        },
        {
          quick: true,
          name: 'col_nombre',
          type: TYPES.INPUT,
          placeholder: t('Nombre'),
          operator: OPERATORS.CONTAINS,
        },
        {
          quick: true,
          name: 'col_apellido',
          type: TYPES.INPUT,
          placeholder: t('Apellido'),
          operator: OPERATORS.CONTAINS,
        },
        {
          quick: true,
          name: 'cnih_porcentaje_excento',
          type: TYPE_CHECKBOX,
          labelForCheckbox: t('Proyecto fijo'),
          operator:  OPERATORS.GREATERTHAN,
        },
        {
          quick: false,
          name: 'col_fecha_alta',
          type: TYPE_DATE,
          placeholder: t('Fecha ingreso'),
          operator: OPERATORS.CONTAINS,
        },
        {
          quick: false,
          name: 'col_activo',
          type: TYPE_CHECKBOX,
          labelForCheckbox: t('Activo'),
          operator:  OPERATORS.CONTAINS,
  
        },
        {
          quick: false,
          name: 'col_fecha_baja',
          type: TYPE_DATE,
          placeholder: t('Fecha baja'),
          operator: OPERATORS.CONTAINS,
        },
        ...listLevels,
        {
          quick: false, 
          name: 'cargo_nombre',
          type: TYPES.COMBOBOXTEXT,
          placeholder: t('Cargo'),
          operator: OPERATORS.CONTAINS,
          contextForCombobox:listcargo || []
        },
        {
          quick: false,
          name: 'us_perid',
          type: TYPES.COMBOBOX_USER,
          placeholder: t('Tipo usuario'),
          operator: OPERATORS.CONTAINS,
          contextForCombobox: profiles.map(p => ({ key: p.per_id, text: p.per_nombre })),
        },
      ],
      [nodes,listcargo,listLevels]
  );

  return (
      <>
        {(nodes || listcargo || listLevels)  && (
            <>
              {mode === GRID_MODE ? (
                  <CollaboratorGridList
                      changeBlockUI={props.changeBlockUI}
                      baseUrl={baseUrl}
                      quickFilters={quickFilters}
                      onItemClick={onItemClick}
                      onClickCardMode={() => setMode(CARD_MODE)}
                      onClickGridMode={() => setMode(GRID_MODE)}
                      mode={mode}
                      courier={props.courier}
                      keyList={'colaboradores'}
                      system={props.system} user={props.user}
                  ></CollaboratorGridList>
              ) : (
                  <CollaboratorCardList
                      changeBlockUI={props.changeBlockUI}
                      baseUrl={baseUrl}
                      quickFilters={quickFilters}
                      onItemClick={onItemClick}
                      onClickCardMode={() => setMode(CARD_MODE)}
                      onClickGridMode={() => setMode(GRID_MODE)}
                      courier={props.courier}
                      mode={mode}
                  ></CollaboratorCardList>
              )}
            </>
        )}
      </>
  );
};
